'use client'

import React from "react";
import {cn} from "@/lib/utils";
import {PortableText} from "@portabletext/react";
import {richTextComponent} from "@/sanity/sanityPortableText";
import {PortableTextBlock} from "sanity";

export default function CornerList({
  items,
  color = "#D9F9B9",
  className = "",
}: {
  items: {text: PortableTextBlock[]}[];
  color?: string;
  className?: string;
}){
  if (!items || items.length === 0) return null;

  return (
    <ul className={cn(
      "list-none p-0 m-0 flex flex-col items-start gap-[2.5rem] prose-strong:font-light prose-strong:text-white prose-p:font-light prose-p:text-white/60",
      className
    )}>
      {items.map((listItem, listIndex) => (
        <li
          key={listIndex}
          className="flex items-center m-0 p-0 gap-[1rem]"
        >
          <div
            className="flex-shrink-0 w-[1.5rem] h-[1.5rem] [clip-path:polygon(0_0,calc(100%-.75rem)_0,100%_.75rem,100%_100%,0_100%)]"
            style={{
              backgroundColor: color,
            }}
          />
          <div className="richtext richtext-start prose-p:leading-[1.1em] prose-p:mb-0">
            <PortableText
              value={listItem.text}
              components={richTextComponent}
            />
          </div>
        </li>
      ))}
    </ul>
  );
}
